@if (dataVisible$ | async) {
    @if (formGroup.get('saldoEigenWoning')?.value != null) {
    <form [formGroup]="formGroup">
      @if ((formGroup.get('eigenWoningForfait')?.value ?? 0) > 0) {
        <div class="row">
          <div class="col-7">
            Eigenwoningforfait
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="eigenWoningForfait"
                                              id="eigenWoningForfait"
                                              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>
      }

      @if ((formGroup.get('huurinkomstenEW')?.value ?? 0) > 0) {
        <div class="row">
          <div class="col-7">
            Belaste huurinkomsten eigen woning (70%)
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control
              [decimals]="0"
              align="right"
              class="custom-input-150"
              formControlName="huurinkomstenEW"
              id="huurinkomstenEW"
              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>
      }

      @if ((formGroup.get('eigenWoningRente')?.value ?? 0) > 0) {
        <div class="row">
          <div class="col-7">
            Af: rente eigenwoningschulden
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="eigenWoningRente"
                                              id="eigenWoningRente"
                                              prefix="€ -"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>
      }

      @if ((formGroup.get('kostenEigenWoningSchuld')?.value ?? 0) > 0) {
        <div class="row">
          <div class="col-7">
            Af: kosten financiering eigen woningschuld
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="kostenEigenWoningSchuld"
                                              id="kostenEigenWoningSchuld"
                                              prefix="€ -"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>
      }

      @if ((formGroup.get('renteRestschuldEigenWoning')?.value ?? 0) > 0) {
        <div class="row">
          <div class="col-7">
            Af: rente inzake restschulden
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="renteRestschuldEigenWoning"
                                              id="renteRestschuldEigenWoning"
                                              prefix="€ -"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>
      }

      @if ((formGroup.get('belastDeelKapitaalverzekering')?.value ?? 0) > 0) {
        <div class="row">
          <div class="col-7">
            Belast deel kapitaalverzekering
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="belastDeelKapitaalverzekering"
                                              id="belastDeelKapitaalverzekering"
                                              prefix="€"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>
      }

      @if ((formGroup.get('erfpachtcanon')?.value ?? 0) > 0) {
        <div class="row">
          <div class="col-7">
            Af: betaalde erfpachtcanon
          </div>
          <div class="col-2">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="erfpachtcanon"
                                              id="erfpachtcanon"
                                              prefix="€ -"
            ></snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
        </div>
      }
      <div class="row">
        <div class="col-7">
          <p><b>Inkomsten eigen woning</b></p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="saldoEigenWoning"
                                            id="saldoEigenWoning"
                                            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
      </div>
    </form>
  } @else {
    <p>Er is geen eigen woning of eigenwoningschuld ingevuld in de aangifte.</p>
  }
}
